import { Box, Button, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useField } from 'formik';
import React from 'react';

import { ReactComponent as DeleteIcon } from '../../../assets/delete-icon.svg';
import { ErrorText } from '../../onboarding/styles/styledComponents';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface FormFileUploadProps {
  name: string;
}

export const FormFileUpload: React.FC<FormFileUploadProps> = ({ name }) => {
  const [{ value }, meta, { setValue }] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';

  return (
    <Box
      sx={{
        borderRadius: '7px',
        border: '1px solid',
        borderColor: 'text.mainLight',
        padding: '10px',
        minHeight: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
      }}
    >
      <Box
        sx={{
          borderRadius: '7px',
          border: '0.6px dashed',
          borderColor: value ? 'primary.main' : 'text.shadyGray',
          background: value ? 'rgba(32, 87, 166, 0.12)' : 'rgba(200, 200, 200, 0.12)',
          height: '160px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <>
          <Typography
            sx={{
              color: '#6C737F',
              fontSize: '14px',
              fontWeight: '500',
              wordBreak: 'break-word',
            }}
          >
            {value ? value.name : 'No file choosen'}
          </Typography>
          {value && (
            <IconButton
              onClick={async () => setValue(null)}
              sx={{ position: 'absolute', top: '5px', right: '5px' }}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Button
          variant='contained'
          component='label'
          sx={{
            borderRadius: '7px',
            bgcolor: 'primary.main',
            minWidth: { xs: '100%', lg: '200px' },
            color: 'common.white',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          Browse file
          <VisuallyHiddenInput
            type='file'
            id={name}
            onChange={event => {
              setValue(event.currentTarget.files?.[0]);
            }}
          />
        </Button>
      </Box>
      <ErrorText sx={{ textAlign: 'center' }}>{errorText}</ErrorText>
    </Box>
  );
};
